import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TitleInput } from "shared/cx-components/cx-components.style";
import { GenericButton } from "shared/ui-basics";
import styled from "styled-components/macro";
import { isNullOrEmpty } from "utils/helpers";

interface TaxonomyCreateItemProps {
	onCreate: (params: { name: string }) => void;
	tabKey?: string;
}

const TaxonomyCreateItem: React.FC<TaxonomyCreateItemProps> = ({ onCreate, tabKey }) => {
	const { t } = useTranslation();
	const [name, setName] = useState<string>("");

	// Reset name when tabKey changes
	useEffect(() => {
		setName("");
	}, [tabKey]);

	return (
		<InputContainer>
			<TitleInput
				value={name}
				title={name}
				color="#262626"
				fontSize="14px"
				fontWeight={600}
				noborder="true"
				className="ps-0"
				name="name"
				placeholder={t("NEW_ITEM")}
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
				autoFocus={true}
			/>
			<GenericButton
				variant="dark"
				icon="PLUS"
				iconClassName="me-1"
				onClick={() => {
					onCreate({ name });
					setName("");
				}}
				disabled={isNullOrEmpty(name)}>
				{t("ASPX_108")}
			</GenericButton>
		</InputContainer>
	);
};

export default TaxonomyCreateItem;

const InputContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 72px;
	padding: 16px;
	border-radius: 4px;
	border: 1px solid #333;
	margin-top: 40px;
`;
